import React from 'react';
import { WorkflowHeader } from 'ui-toolkit';
import { SubmitButton } from './SubmitButton';

interface IFormHeaderProps {
  onCancel: () => void;
}

export const FormHeader: React.FC<IFormHeaderProps> = ({ onCancel }) => (
  <WorkflowHeader labelBack={'Cancel'} title={'Create a new order'} onBackClick={onCancel}>
    <SubmitButton />
  </WorkflowHeader>
);
